import React from 'react';
import { BsLinkedin, BsGithub } from 'react-icons/bs';
import { TiSocialInstagram } from 'react-icons/ti';

export const profileData = [
  {
    id: 1,
    name: 'Instagram',
    icon: <TiSocialInstagram className="profile-link-icon" />,
    href: 'https://www.instagram.com/kyriakos.94/',
  },
  {
    id: 2,
    name: 'LinkedIn',
    icon: <BsLinkedin className="profile-link-icon" />,
    href: 'https://www.linkedin.com/in/popovicnedeljko994/',
  },
  {
    id: 3,
    name: 'GitHub',
    icon: <BsGithub className="profile-link-icon" />,
    href: 'https://github.com/popovic-nedeljko',
  },
];
